__turbopack_context__.v({
  "conditions": "_1Cm57W_conditions",
  "drawer": "_1Cm57W_drawer",
});
